import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "text-center text-gray-900 bg-opacity-50 rounded-lg bp-4 sm:mt-0 sm:col-span-2" }
const _hoisted_2 = {
  class: "px-4 py-8 mx-auto text-left sm:py-6 sm:px-6 lg:px-5 rounded-2xl",
  id: "show-opp-near"
}
const _hoisted_3 = {
  key: 0,
  class: "mt-4 text-sm text-sa-raspberry-600"
}
const _hoisted_4 = {
  key: 1,
  class: "grid grid-cols-1 pb-5 mt-4 gap-x-4 md:gap-x-5 md:gap-y-1 gap-y-3 sm:grid-cols-3 md:grid-cols-5"
}
const _hoisted_5 = {
  key: 0,
  class: "flex items-start space-x-4 text-base sm:text-sm"
}
const _hoisted_6 = { class: "flex-none mt-1" }
const _hoisted_7 = ["href", "alt", "title"]
const _hoisted_8 = ["src", "alt", "title"]
const _hoisted_9 = { class: "flex-grow" }
const _hoisted_10 = ["href", "alt", "title"]
const _hoisted_11 = {
  key: 1,
  class: "flex items-start space-x-4 text-base sm:text-sm"
}
const _hoisted_12 = { class: "flex-none mt-1" }
const _hoisted_13 = ["href", "alt", "title"]
const _hoisted_14 = ["src", "alt", "title"]
const _hoisted_15 = { class: "flex-grow" }
const _hoisted_16 = ["href", "alt", "title"]

import {computed, onMounted, Ref, ref} from "vue";
import {client} from '@/shared';
import {
    GetNewestGuidesRequest, GetNewestGuidesResponse
} from "@/dtos";


export default /*@__PURE__*/_defineComponent({
  __name: 'GetNewestGuides',
  setup(__props) {

// @ts-ignore
const recentGuides = ref([]);

onMounted(async () => {
    await getNewestGuides();
});

const isFetching = ref(true);
const getNewestGuides = async () => {
    await client.get<GetNewestGuidesResponse>(new GetNewestGuidesRequest())
        .then(response => {
            recentGuides.value = response.results;
            isFetching.value = false;
        });
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("h4", {
        class: "text-lg font-extrabold tracking-tight text-sa-raspberry-900 sm:text-xl lg:text-lg",
        id: "learning-mod"
      }, "Newest Guides", -1)),
      (isFetching.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Loading... "))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recentGuides.value, (guide) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "opp-near-card",
                key: guide.id
              }, [
                (guide.id.startsWith('shows'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("a", {
                          href: `/${guide.urlSlug}`,
                          alt: guide.title,
                          title: guide.title
                        }, [
                          _createElementVNode("img", {
                            class: "object-cover w-8 rounded-lg shadow-lg",
                            src: guide.logo,
                            alt: `${guide.title} logo`,
                            title: `${guide.title} logo`
                          }, null, 8, _hoisted_8)
                        ], 8, _hoisted_7)
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("a", {
                          class: "block font-medium hover:underline text-sa-raspberry-900",
                          href: `/${guide.urlSlug}`,
                          alt: guide.title,
                          title: guide.title
                        }, [
                          _createElementVNode("h3", null, _toDisplayString(guide.title), 1)
                        ], 8, _hoisted_10),
                        _cache[0] || (_cache[0] = _createElementVNode("dl", { class: "text-sa-raspberry-600" }, [
                          _createElementVNode("dt", { class: "sr-only" }, "Type"),
                          _createElementVNode("dd", null, [
                            _createElementVNode("span", { class: "text-xs" }, "Show Research")
                          ])
                        ], -1))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (guide.id.startsWith('learn'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        (guide.imageUrl)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: `/${guide.id}/${guide.slug}`,
                              alt: guide.topic,
                              title: guide.topic
                            }, [
                              _createElementVNode("img", {
                                class: "object-cover w-8 rounded-lg shadow-lg",
                                src: guide.imageUrl,
                                alt: guide.topic,
                                title: guide.topic
                              }, null, 8, _hoisted_14)
                            ], 8, _hoisted_13))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("a", {
                          class: "block font-medium hover:underline text-sa-raspberry-900",
                          href: `/${guide.id}/${guide.slug}`,
                          alt: guide.topic,
                          title: guide.topic
                        }, [
                          _createElementVNode("h3", null, _toDisplayString(guide.topic), 1)
                        ], 8, _hoisted_16),
                        _cache[1] || (_cache[1] = _createElementVNode("dl", { class: "text-sa-raspberry-600" }, [
                          _createElementVNode("dt", { class: "sr-only" }, "Type"),
                          _createElementVNode("dd", null, [
                            _createElementVNode("span", { class: "text-xs" }, "Learning Module")
                          ])
                        ], -1))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
    ])
  ]))
}
}

})